import React from "react";
import Footer from "../../components/LPfooter";
import Header from "../../components/LPheader";
import SectionAccount from "../../components/LPsectionAccount";
import SectionAccountBussiness from "../../components/LPsectionAccountBussiness";
import SectionBenefits from "../../components/LPSectionBenefits";
import SectionCountWithStric from "../../components/LPsectionCountWithStric";
import SectionDayaDayAccount from "../../components/LPsectionDayaDayAccount";
import SectionFAQ from "../../components/LPSectionFAQ";
import SectionProduct from "../../components/LPsectionProduct";
import SectionStart from "../../components/LPsectionStart";

import { Container } from "./styles";

import Helmet from "react-helmet";
// import { useTheme } from "styled-components";

const Home: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Stric - A conta digital perfeita</title>
        <meta name="description" content="Stric - A conta digital perfeita" />
        <meta name="theme-color" content="#38D2D9" />
      </Helmet>

      <Container>
        <Header />
        <SectionStart />
        <SectionProduct />
        <SectionAccount />
        <SectionDayaDayAccount />
        <SectionAccountBussiness />
        <SectionBenefits />
        <SectionFAQ />
        <SectionCountWithStric />
        <Footer />
      </Container>
    </>
  );
};

export default Home;
